export const VistalaroLogo = ({ className = "" }) => (
  <svg
    viewBox="0 0 172 44"
    className={className}
    role="img"
    aria-label="vistalaro"
    fill="none"
  >
    <text
      x="0"
      y="33"
      fontFamily="Quicksand, sans-serif"
      fontWeight="600"
      fontSize="34"
      letterSpacing="-1.2"
      fill="currentColor"
    >
      vistalaro
    </text>
    <circle cx="18.5" cy="38" r="3.4" fill="#13D8A0" />
  </svg>
);
